module.exports = __webpack_public_path__ + "static/media/search.3633a5e5.png";